import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/shared/components/ui/tooltip";
import { CircleHelp } from "lucide-react";

export function InfoIconTooltip({ text, id }: { text: string; id?: string }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          id={id}
          type="button"
          className="text-muted-foreground hover:text-foreground inline-flex items-center"
        >
          <CircleHelp className="h-4 w-4" />
        </button>
      </TooltipTrigger>
      <TooltipContent className="bg-background text-foreground max-w-sm border text-left text-xs">
        {text}
      </TooltipContent>
    </Tooltip>
  );
}
